<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-add-bookmark`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40 4a2 2 0 011.995 1.85L42 6l-.001 16.735-4 .062L38 8H27v9.997a2 2 0 01-2.77 1.846L20 18.077l-4.23 1.766A2 2 0 0113 17.997V8h-3v33h14.999v4H8a2 2 0 01-1.995-1.85L6 43V6a2 2 0 011.85-1.995L8 4h32zm-2 22a1 1 0 011 1v6h6a1 1 0 011 1v2a1 1 0 01-1 1h-6v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6h-6a1 1 0 01-1-1v-2a1 1 0 011-1h6v-6a1 1 0 011-1h2zM23 8h-6v6.995l3-1.253 3 1.253V8z"/></svg>
</template>
<script>

export default {
  name: 'IconAddBookmark',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
